import {Card, Form} from "react-bootstrap";
import {React, useEffect, useState, useRef} from "react";
import styles from "./CartProductNew.module.css";
import  './CartProductNew.css'
import InputGroup from "react-bootstrap/InputGroup";
import {toNumber} from "lodash";
import {ConfirmPopup} from "primereact/confirmpopup";
import {Button} from "primereact/button";
import {Image} from 'react-bootstrap';
//import { Image } from 'primereact/image';
import  noPhoto from "../../../common/image/no photo stub.jpg"
import {useCartContext} from "../../../Context/CartContext";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {useWindowDimensions} from "../../../Context/WindowDimensionsContext";
import {Tooltip} from "primereact/tooltip";
import { OverlayPanel } from 'primereact/overlaypanel';

export const CartProductNew = ({
                                id,
                                isSet,
                                stockId,
                                discountLabel,
                                name,
                                number,
                                recommendPrice,
                                priceList,
                                priceListIndex,
                                count,
                                calcPrice,
                                productPrice,
                                productStockPrice,
                                isDiscount,
                                goalAchieved,
                                isLoading,
                                setIsLoading,
                                urls,
                                isBalanceEnds,
                                toast
                            }) => {
    const [oldCount, setOldCount] = useState(0)
    const [itemPriceIndex, setItemPriceIndex] = useState(0)
    const [prices, setPrices] = useState([]);
    const [recommendPriceVue, setRecommendPriceVue] = useState('');
    const [productCount, setProductCount] = useState(0);
    const timerRef = useRef(null);

    //balance
    const balanceTooltipRef = useRef(null)
    const balanceOverlayPanelRef = useRef(null);
    //const balanceTooltipContent = (<span>Товар має статус «Закінчується», тобто залишків дуже мало. Через можливі затримки з оновленням інформації, <b>наявність цих товарів є умовною</b></span>)
    const balanceTooltipContent = `Товар має статус «Закінчується», тобто залишків дуже мало. Через можливі затримки з оновленням інформації, наявність цих товарів є умовною`

    const [profit, setProfit] = useState(0);
    const [profitString, setProfitString] = useState(0);

    const [totalAmount, setTotalAmount] = useState(0);
    const [totalAmountString, setTotalAmountString] = useState(0);

    const {updateBaseOrderItem, updateStockItem, deleteBaseOrderItem, removeStockItemFromCart} = useCartContext()
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();

    //confirm
    const removeBtn = useRef(null);

    const [visible, setVisible] = useState(false);


    const incrementCount = () => {
        setProductCount(productCount + 1);
    }

    const decrementCount = () => {
        if (productCount > 1) {
            setProductCount(productCount - 1)
        }
    }

    const countHandler = (e) => {
        debugger
        if (e.target.value === "" || toNumber(e.target.value) === 0) {
            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Помилка',
                detail: 'Кількість не може бути менше 1',
                life: 1000
            });
            setProductCount(1)
        } else if (e.target.validity.valid && !(e.target.value === "" || e.target.value === undefined || isNaN(e.target.value))) {
            setProductCount(parseFloat(e.target.value))
        }
    }

    // const countHandler = (e) => {
    //     debugger
    //     if (e.value === "" || toNumber(e.value) === 0) {
    //         toast.current.clear();
    //         toast.current.show({
    //             severity: 'error',
    //             summary: 'Помилка',
    //             detail: 'Кількість не може бути менше 1',
    //             life: 1000
    //         });
    //         setProductCount(1)
    //     }
    //     else if (e.originalEvent.target.validity.valid && !(e.originalEvent.target.value === "" || e.originalEvent.target.value === undefined || isNaN(e.originalEvent.target.value))) {
    //         setProductCount(e.value)
    //     }
    // }

    const countHandleClick = (e) => {
        e.target.select();
    }

    const accept = () => {
        removeFromCartHandler()
    };

    const reject = () => {
        setVisible(false);
    };

    const onHide =() =>{
        setVisible(false);
    }
    const onShow = () =>{
        setVisible(true);
        setTimeout(() =>{
            setVisible(false);
        },5000)
    }

    const renderFooter = () => {
        return (
            <div style={{float: 'right', margin:'5px'}}>
                <Button style={{marginRight:'5px', padding:'5px 10px'}} severity="danger" label="Так" icon="pi pi-check" onClick={accept} />
                <Button style={{padding:'5px 10px'}} label="Ні" icon="pi pi-times" onClick={reject} className="p-button-secondary" />
            </div>
        );
    };

    const removeFromCartHandler = () => {
        debugger
        if(stockId == null)
        {
            deleteBaseOrderItem(id).then((data) => {
                setVisible(false);
            });
        }
        else{
            removeStockItemFromCart(id, stockId).then((data) => {
                setVisible(false);
            })
        }
    }

    const updateCart = () => {
        setIsLoading(true);
        if(stockId == null)
        {
            updateBaseOrderItem({
                id: id,
                name: name,
                priceList: priceList,
                number: number,
                priceListIndex: itemPriceIndex,
                count: productCount,
            }).then((data) => {
                setTimeout(() => {
                    setIsLoading(false);
                },100)
                //setIsLoading(false);
                if (data.isSucccess) {
                    console.log('Cart updated')
                } else {
                    toast.current.clear();
                    toast.current.show({
                        severity: 'error',
                        summary: 'Помилка оновлення кошика',
                        detail: data.message,
                        life: 1000
                    });
                }
            })
        }
        else(
            updateStockItem({
                id: id,
                name: name,
                priceList: priceList,
                number: number,
                priceListIndex: itemPriceIndex,
                count: productCount
            }, stockId).then((data) => {
                setTimeout(() => {
                    setIsLoading(false);
                },100)
                if (data.isSucccess) {
                    console.log('Cart updated')
                } else {
                    toast.current.clear();
                    toast.current.show({
                        severity: 'error',
                        summary: 'Помилка оновлення кошика',
                        detail: data.message,
                        life: 1000
                    });
                }
            })
        )
    }

    //для перевода в строку грн
    useEffect(() => {
        const numProft = parseFloat(profit);
        const numTotalAmount= parseFloat(totalAmount);

        setProfitString(numProft.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setTotalAmountString(numTotalAmount.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    },[profit, totalAmount])

    useEffect(() => {
        if (recommendPrice === 0) {
            setRecommendPriceVue('');
        } else {
            setRecommendPriceVue(recommendPrice);
        }
    }, [recommendPrice])

    useEffect(() => {
        setProductCount(count);
        setItemPriceIndex(priceListIndex)
    }, [count]);

    useEffect(() => {
        if (priceList.length !== 0) {
            setPrices(priceList);
        }
    }, [priceList]);

    useEffect(() => {
        //якщо продукт в комплекті, то не відправляємо зміну його кількості на сервер.
        if(isSet === true){return;}

        // Очищаем таймер, если он уже был запущен
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        if (productCount) {
            // Запускаем таймер на 700 миллисекунд
            timerRef.current = setTimeout(() => {
                updateCart();
            }, 700);
        }

        // Очищаем таймер при размонтировании компонента
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    },[productCount])

    useEffect(() => {
        setTotalAmount(calcPrice)
        //прибыль
        if (recommendPrice !== 0) {
            setProfit(((parseFloat(recommendPrice) * count) - parseFloat((priceList[itemPriceIndex].UoMPrice * parseFloat(count)))).toFixed(2))
        }
    }, [count, calcPrice])

    useEffect(() => {
        //калькуляция общей цены всех продуктов
        if (recommendPrice !== 0) {
            setProfit(((parseFloat(recommendPrice) * productCount) - parseFloat((priceList[itemPriceIndex].UoMPrice * parseFloat(productCount)))).toFixed(2))
        }
    }, [totalAmount]);

    if (priceList.length === 0) {
        return (<div></div>)
    }

    if(viewPortWidth > 1000)
    {
        return (
            <div>
                <div className={`${isSet === true ? styles.cardSet : styles.card} ${(productStockPrice  && productPrice  && productPrice.UoMPrice > 0) ? styles.cardDiscountBoxShadow : null} custom-cart-card`}>
                    <Image src={urls.length > 0 ? urls[0] : noPhoto} alt="Image"
                           style={{width: '100%', alignSelf: "end"}}/>
                    <div style={{display: "grid", gridTemplateRows: '20px 1fr'}}>
                        <div className={styles.productInfo}>
                            <div className={styles.name_discount}>
                                <div style={{display: 'flex'}}>
                                    <span className={styles.productName} style={{fontWeight: "bold"}}>{name}</span>
                                </div>
                            </div>
                        </div>

                        <div className={isSet === true ? styles.inputsSetWrapper : styles.inputsWrapper}>

                            <div className={styles.inputWrapper}>
                                <span className={`${styles.inputDescription}`}>Ціна</span>
                                <div className={`${styles.input} ${styles.alignSelfCenter}`}>
                                    {isDiscount && goalAchieved ?
                                        <span style={{textDecoration: "line-through", paddingRight: '15px'}}>
                                                    {(priceList[itemPriceIndex].UoMPrice * 100 / 95).toLocaleString('uk-UA', {
                                                        style: 'decimal',
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span> : null}
                                    {productStockPrice  && productPrice  && productPrice.UoMPrice > 0 ?
                                        <span style={{textDecoration: "line-through", paddingRight: '15px'}} >
                                             {productPrice.UoMPrice.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                         </span>
                                        : null}
                                    <span className={(isDiscount && goalAchieved) || (productStockPrice  && productPrice  && productPrice.UoMPrice > 0) ? styles.discountColor : null}>{priceList[itemPriceIndex].UoMPrice.toLocaleString('uk-UA', {
                                        style: 'decimal',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}</span>
                                </div>
                            </div>

                            <div className={styles.inputWrapper}>
                            <Tooltip target={balanceTooltipRef} style={{width: viewPortWidth * 0.3 +'px'}} content={balanceTooltipContent} position='top' />
                                <span className={styles.inputDescription}>Кількість {isBalanceEnds && <i style={{fontSize:'1.2rem'}}ref={balanceTooltipRef} className={`pi pi-exclamation-triangle custom-warning-icon`} />}</span>
                                {isSet === true ? <span className={`${styles.input} ${styles.alignSelfCenter}`}>{productCount}</span> :
                                    <div className='p-inputgroup p-cart-custom-input-desctop' style={{height: '100%'}}>
                                        <Button icon="pi pi-minus" onClick={decrementCount} rounded text raised
                                                style={{borderRadius: '10px 0px 0px 10px', height: '30px', background:'#fbce07', color:'#666666'}}/>
                                        <Form.Control  disabled={isSet} style={{textAlign: 'center', borderRadius:'0px'}} type="text" min={0} pattern="[0-9]*"
                                                       onClick={countHandleClick} onInput={countHandler}
                                                       value={productCount}/>
                                        <Button icon="pi pi-plus" onClick={incrementCount} rounded text raised
                                                style={{borderRadius: '0px 10px 10px 0px', height: '30px', background:'#fbce07', color:'#666666'}}/>
                                    </div>
                                }
                            </div>

                            <div className={`${styles.inputWrapper}`}>
                                <span className={`${styles.inputDescription} ${styles.justifySelfEnd}`}>Сума</span>
                                <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter} `}>
                                    {totalAmountString}
                                </div>
                            </div>

                            <div className={`${styles.inputWrapper}`}>
                                <span className={`${styles.inputDescription} ${styles.justifySelfEnd}`}>РРЦ</span>
                                <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter}`}>
                                    {recommendPriceVue.toLocaleString('uk-UA', {
                                        style: 'decimal',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </div>
                            </div>

                            <div className={`${styles.inputWrapper}`}>
                                <span className={`${styles.inputDescription} ${styles.justifySelfEnd}`}>Прибуток</span>
                                <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter} ${styles.greenForestColor}`}>
                                    {profitString}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={styles.cardEnd}>
                        {isDiscount ? <div style={{position: 'relative'}}>
                            <Button style={{
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                color: '#d50707',
                                zIndex: 1000,
                                padding: 0
                            }} label={discountLabel} className="percentage-icon p-button-rounded p-button-text"
                                    rounded/>
                        </div> : <div></div>}
                        {!isSet ? <Button ref={removeBtn} key={id + name + 'key'} onClick={removeFromCartHandler}
                                          icon="pi pi-times" label="" style={{borderRadius: '50%'}} rounded
                                          severity="danger"
                                          className="p-button p-button-danger p-button-raised p-button-text "></Button> : null}
                    </div>
                </div>

            </div>
        )
    }

    else if(viewPortWidth <= 1000 && viewPortWidth > 550){
        return (
            <div >

                <div className={`${isSet === true ? styles.cardSet : styles.card} ${(productStockPrice  && productPrice  && productPrice.UoMPrice > 0) ? styles.cardDiscountBoxShadow : null} custom-cart-card`}>
                    <Image src={urls.length > 0 ? urls[0] : noPhoto} alt="Image" style={{width:'100%', alignSelf:"end"}} />
                    <div style={{display:"grid", gridTemplateRows:'20px 1fr'}}>
                        <div className={styles.productInfo}>
                            <div className={styles.name_discount}>
                                <div style={{display:'flex'}}>
                                    <span className={styles.productName} style={{fontWeight:"bold"}}>{name}</span>
                                </div>
                            </div>
                        </div>
                        
                        <div  className={styles.inputsWrapper}>

                            <div className={styles.inputWrapper}>
                                <span className={`${styles.inputDescription}`}>Ціна</span>
                                <div className={`${styles.input} ${styles.alignSelfCenter}`}>
                                    {isDiscount && goalAchieved ? <span style={{textDecoration:"line-through", paddingRight:'10px'}} >
                                                    {(priceList[itemPriceIndex].UoMPrice * 100 / 95).toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </span> : null}
                                    {productStockPrice  && productPrice  && productPrice.UoMPrice > 0 ?
                                        <span style={{textDecoration: "line-through", paddingRight: '10px'}} >
                                             {productPrice.UoMPrice.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                         </span>
                                        : null}
                                    <span className={(isDiscount && goalAchieved) || (productStockPrice  && productPrice  && productPrice.UoMPrice > 0) ? styles.discountColor : null}>{priceList[itemPriceIndex].UoMPrice.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                            </div>

                            <div className={styles.inputWrapper}>
                            <OverlayPanel className={styles.overlayPanelStyles} style={{width: viewPortWidth * 0.4 +'px'}} ref={balanceOverlayPanelRef}>
                                <span  >{balanceTooltipContent}</span>
                            </OverlayPanel>
                                <div style={{display:"flex", flexDirection: "row", gap:'5px'}}>
                                    <span className={styles.inputDescription}>Кількість</span>
                                    <span>{isBalanceEnds && <i onClick={(e) => balanceOverlayPanelRef.current.toggle(e)} className={`pi pi-exclamation-triangle custom-warning-icon`} />}</span>
                                </div>
                                {isSet === true ? <span className={`${styles.input} ${styles.alignSelfCenter}`}>{productCount}</span> :
                                    <div className='p-inputgroup' style={{height:'100%'}}>
                                        <Button icon="pi pi-minus" onClick={decrementCount} rounded text raised  style={{borderRadius: '10px 0px 0px 10px', height: '30px', background:'#fbce07', color:'#666666'}} />
                                        <Form.Control  disabled={isSet} style={{textAlign: 'center',  borderRadius:'0px'}} type="text" min={0} pattern="[0-9]*"
                                                       onClick={countHandleClick} onInput={countHandler}
                                                       value={productCount}/>
                                        <Button icon="pi pi-plus" onClick={incrementCount} rounded text raised style={{borderRadius: '0px 10px 10px 0px', height: '30px', background:'#fbce07', color:'#666666'}} />
                                    </div>
                                }
                            </div>

                            <div className={`${styles.inputWrapper}`}>
                                <span className={`${styles.inputDescription} ${styles.justifySelfEnd}`}>Сума</span>
                                <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter}`}>
                                    {totalAmountString}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className={styles.cardEnd}>
                        {isDiscount ? <div style={{position:'relative'}}>
                            <Button style={{ fontSize:'1.1rem', fontWeight: '600', color: '#d50707', zIndex: 1000, padding:0}} label={discountLabel} className="percentage-icon p-button-rounded p-button-text"  rounded/>
                        </div>: <div></div>}
                        {!isSet ? <Button ref={removeBtn} key={id+name+'key'} onClick={removeFromCartHandler} icon="pi pi-times" label="" style={{borderRadius:'50%'}} rounded severity="danger" className="p-button p-button-danger p-button-raised p-button-text "></Button>: null}
                    </div>
                    {isSet !== true ?  <span></span> : null}
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", }}>
                        <div className={`${styles.inputWrapper}`}>
                            <span className={`${styles.inputDescription}`}>РРЦ</span>
                            <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter}`}>
                                {recommendPriceVue.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </div>
                        </div>

                        <div className={`${styles.inputWrapper}`}>
                            <span className={`${styles.inputDescription} ${styles.justifySelfEnd}`}>Прибуток</span>
                            <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter} ${styles.greenForestColor}`}>
                                {profitString}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    else if(viewPortWidth <= 550){
        return (
            <div >
                <div className={`${isSet === true ? styles.cardSet : styles.card} ${(productStockPrice  && productPrice  && productPrice.UoMPrice > 0) ? styles.cardDiscountBoxShadow : null} custom-cart-card`}>
                    <OverlayPanel className={styles.overlayPanelStyles} style={{width: viewPortWidth * 0.6 +'px'}} ref={balanceOverlayPanelRef}>
                         <span>{balanceTooltipContent}</span>
                    </OverlayPanel>
                    {isBalanceEnds && <i onClick={(e) => balanceOverlayPanelRef.current.toggle(e)} className={`pi pi-exclamation-triangle custom-warning-icon ${styles.warningBalanceIconMobile}`} />}
                    <Image src={urls.length > 0 ? urls[0] : noPhoto} alt="Image"
                           style={{width: '100%', alignSelf: "end"}}/>
                    <div style={{display: "grid", gridTemplateRows: '1fr'}}>
                        <div className={styles.productInfo}>
                            <div className={styles.name_discount}>
                                <div style={{display: 'flex'}}>
                                    <span className={styles.productName} style={{fontWeight: "bold"}}>{name}</span>
                                </div>
                            </div>
                        </div>

                        <div style={{display:"grid", gridTemplateColumns:'1fr 1fr', gridGap:'10px'}}>
                            <div className={styles.inputWrapper}>

                                <span className={`${styles.inputDescription}`}>Ціна</span>
                                <div className={`${styles.input} ${styles.alignSelfCenter}`}>
                                    {isDiscount && goalAchieved ?
                                        <span  style={{textDecoration: "line-through", paddingRight: '5px'}}>
                                                    {(priceList[itemPriceIndex].UoMPrice * 100 / 95).toLocaleString('uk-UA', {
                                                        style: 'decimal',
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span> : null}
                                    {productStockPrice  && productPrice  && productPrice.UoMPrice > 0 ?
                                        <span style={{textDecoration: "line-through", paddingRight: '5px'}} >
                                             {productPrice.UoMPrice.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                         </span>
                                        : null}
                                    <span className={(isDiscount && goalAchieved) || (productStockPrice  && productPrice  && productPrice.UoMPrice > 0) ? styles.discountColor : null}>{priceList[itemPriceIndex].UoMPrice.toLocaleString('uk-UA', {
                                        style: 'decimal',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}</span>
                                </div>


                            </div>
                            <div className={`${styles.inputWrapper}`}>
                                <span className={`${styles.inputDescription} ${styles.justifySelfEnd}`}>РРЦ</span>
                                <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter}`}>
                                    {recommendPriceVue.toLocaleString('uk-UA', {
                                        style: 'decimal',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </div>
                            </div>

                        </div>
                    </div>
                    {isSet !== true ?
                        <div className={styles.cardEnd}>
                            {!isSet ? <Button ref={removeBtn} key={id + name + 'key'} onClick={removeFromCartHandler}
                                              icon="pi pi-times" label="" style={{borderRadius: '50%'}} rounded
                                              severity="danger"
                                              className="p-button p-button-danger  p-button-text "></Button> : null}
                            {isDiscount ? <div className={styles.alignSelfCenter}>
                                <Button style={{
                                    fontSize: '1.1rem',
                                    fontWeight: '600',
                                    color: '#d50707',
                                    zIndex: 1000,
                                    padding: 0
                                }} label={discountLabel} className="percentage-icon p-button-rounded p-button-text"
                                        rounded/>
                            </div> : null}
                        </div>
                    : null}

                    <div style={{display:"grid", gridTemplateRows:'1fr 1fr', justifyItems:'center'}}>
                        <span className={styles.inputDescription}>Кількість</span>
                        {isSet === true ? <span className={styles.input}>{productCount}</span>
                            :
                            <div className='p-inputgroup mobile-cart-input-number-custom' style={{paddingLeft: '5px', paddingRight: '5px'}}>
                                {/*<span className='pi pi-minus'></span>*/}
                                <Button icon="pi pi-minus" onClick={decrementCount} rounded text
                                        style={{borderRadius: '15px 0px 0px 15px', height: '30px'}}/>
                                <Form.Control  disabled={isSet} style={{textAlign: 'center'}} type="text" min={0} pattern="[0-9]*"
                                               onClick={countHandleClick} onInput={countHandler}
                                               value={productCount}/>
                                <Button icon="pi pi-plus" onClick={incrementCount} rounded text
                                        style={{borderRadius: '0px 15px 15px 0px', height: '30px'}}/>
                            </div>
                        }
                    </div>
                    <div style={{display:"flex", justifyContent:"space-between"}}>
                        <div className={`${styles.inputWrapper}`}>
                            <span className={`${styles.inputDescription}`}>Сума</span>
                            <div className={`${styles.input}  ${styles.alignSelfCenter} `}>
                                {totalAmountString}
                            </div>
                        </div>
                        <div className={`${styles.inputWrapper}`}>
                            <span className={`${styles.inputDescription} ${styles.justifySelfEnd}`}>Прибуток</span>
                            <div className={`${styles.input} ${styles.justifySelfEnd} ${styles.alignSelfCenter} ${styles.greenForestColor}`}>
                                {profitString}
                            </div>
                        </div>
                    </div>


                </div>

            </div>
        )
    }
}